import React from 'react';
import { Row, Col } from 'reactstrap';
import PropTypes from 'prop-types'

const PersonNotFound = ({ clubName }) => (
  <Row>
    <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
      <h2>
        Sorry!
      </h2>
      <p>
        De pagina kan niet gevonden worden. Controleer de URL of neem contact op met vereniging {clubName}.
      </p>
    </Col>
  </Row>
);

PersonNotFound.propTypes = {
  clubName: PropTypes.string
}

export default PersonNotFound



// WEBPACK FOOTER //
// ./src/personconsent/PersonNotFound.jsx